import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getFormattedDateTime } from 'app/core/shared/helper/date.helper';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ManagementOfChangeService {
  private _mocRecord: BehaviorSubject<any> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get mocRecord$(): Observable<any> {
    return this._mocRecord.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  getMocRecords(params: any): Observable<any> {
    const url = composeUrl(
      '/v1/Moc/GetMocRecord',
      params
    );

    return this._httpClient.get<any>(url);
  }

  getMocRecordById(mocId: any): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Moc/GetMocRecord/${mocId}`).pipe(
      tap((response: any) => {
        this._mocRecord.next(response);
        return response
      }),
    );
  }

  updateMocRecord(payload: any): Observable<any> {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Moc/UpdateMocRecord`, payload
    ).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  getApplicationTracking(params: any): Observable<any> {
    const url = composeUrl(
      '/v1/Moc/ApplicationTracking',
      params
    );

    return this._httpClient.get<any>(url);
  }

  getMocAppTrackingById(appTrackingId: any): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Moc/ApplicationTracking/${appTrackingId}`).pipe(
      tap((response: any) => {
        this._mocRecord.next(response);
        return response
      }),
    );
  }

  getMocAppTrackingManualById(appTrackingId: any): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Moc/MocAppTrackingDetails/${appTrackingId}`).pipe(
      tap((response: any) => {
        return response.data
      }),
    );
  }

  manualAppTrackClose(payload: any): Observable<any> {
    return this._httpClient.put<any>(`${environment.apiURL}/${environment.apiVersion}/Moc/ManualMocAppTrackClose`, payload
    ).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  downloadMocExcel() {
    const { date, time } = getFormattedDateTime();
    const url = composeUrl(
      `/v1/Moc/DownloadMocExcel`
    );
    this._httpClient.get(url, { responseType: 'blob' })
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `MOC_Records_${date}_${time}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
  }

  downloadAppTrackingExcel() {
    const { date, time } = getFormattedDateTime();
    const url = composeUrl(
      `/v1/Moc/DownloadAppTrackingExcel`
    );

    this._httpClient.get(url, { responseType: 'blob' })
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `MOC_AppTracking_${date}_${time}.xlsx`;;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
  }
}
